'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _httpConstants = require('../../../utils/http/httpConstants');

var _timeUtil = require('../../../utils/timeUtil');

var FormData = global.FormData || require('form-data');

// Constants

// TODO Currently only supports images
//
exports.default = function (mediaHttp) {
    return {
        uploadMediaFile: function uploadMediaFile(file, options) {
            var data = new FormData();
            data.append('file', file);
            data.append('options', JSON.stringify(options));

            var requestConfig = {
                url: 'image',
                method: _httpConstants.METHODS.POST,
                timeout: 5 * _timeUtil.TIMES.MINUTE,
                data: data
            };

            if (data.getHeaders) {
                requestConfig.headers = data.getHeaders();
            }

            return mediaHttp(requestConfig);
        }
    };
};


//////////////////
// WEBPACK FOOTER
// ./src/common/media/mediaService/api/createImageApi.js
// module id = 2281
// module chunks = 0